import dateWithTodayComparator from '@/services/general/dateWithTodayComparator';

export default function echeanceFacturationPreselector(ligneEcheance) {
  ligneEcheance.filter(ligne => dateWithTodayComparator(ligne.datePrevisionnelleFacturation) <= 0)
    .forEach(ligne => {
      ligne.selected = true;
    });
  if (ligneEcheance.filter(ligne => ligne.selected).length !== 0) { return; }
  const mapDatePrev = ligneEcheance.map(
    ligne => new Date(ligne.datePrevisionnelleFacturation).getTime(),
  );
  const minDatePrev = Math.min(...mapDatePrev);
  ligneEcheance.filter(ligne => new Date(ligne.datePrevisionnelleFacturation)
    .getTime() === minDatePrev)
    .forEach(ligne => {
      ligne.selected = true;
    });
}
